import type { components } from "@sagot/api-client";

/**
 * Phase 4 API shapes (WORKFLOWS_P3_P4_CONTRACT.md section P4). The generated client already carries every P4 route, so
 * nothing here is a stand-in: these are aliases that give the feature short names. The hand-written definition shapes
 * (goal, translations, the two new steps) live in `types.ts` next to the other steps.
 */
type Schemas = components["schemas"];

export type VersionList = Schemas["VersionListOut"];
export type VersionItem = Schemas["VersionItemOut"];
export type VersionDetail = Schemas["VersionDetailOut"];
export type VersionDiff = Schemas["DiffOut"];
export type PathDiff = Schemas["PathDiffOut"];
export type StepDiff = Schemas["StepDiffOut"];
export type PathAnalysis = Schemas["AnalysisOut"];
export type StepAnalysis = Schemas["StepAnalysisOut"];
export type TranslationDraft = Schemas["TranslationDraftOut"];
export type HookSpec = Schemas["HookSpecOut"];
export type RunHook = Schemas["RunHookOut"];
export type ConversationRun = Schemas["ConversationRunOut"];
export type ManualRunStarted = Schemas["ManualRunOut"];
export type AutomationStats = Schemas["AutomationOut"];
export type WorkflowGoalOut = Schemas["WorkflowGoalOut"];

/** The step statuses `GET /v1/workflows/{id}/diff` reports (backend `services/workflows/compare.py`). */
export type DiffStatus = "added" | "removed" | "changed" | "moved" | "unchanged";

/** `base` / `target` of the diff route: a version number, or one of these. */
export const DIFF_DRAFT = "draft";
export const DIFF_LIVE = "live";
